import { AgentStatusDotSlot } from './AgentStatusDot'

export type AgentActivityKind =
  | 'thinking'
  | 'planning'
  | 'tool'
  | 'subagent'
  | 'verifying'
  | 'waiting'
  | 'confirm'
  | 'done'
  | 'error'

export type AgentActivityState = {
  label: string
  kind?: AgentActivityKind
}

const KIND_HINT: Record<AgentActivityKind, string> = {
  thinking: '思考中',
  planning: '规划中',
  tool: '调用工具',
  subagent: '子智能体',
  verifying: '校验中',
  waiting: '等待中',
  confirm: '待确认',
  done: '已完成',
  error: '运行失败',
}

export function AgentActivityBar({
  activity,
  running = false,
}: {
  activity?: AgentActivityState | null
  running?: boolean
}) {
  if (!activity?.label && !running) return null
  const label = activity?.label?.trim() || '处理中…'
  const kind = activity?.kind
  const status =
    kind === 'error'
      ? 'failed'
      : kind === 'done'
        ? 'completed'
        : kind === 'confirm'
          ? 'awaiting_confirmation'
          : kind === 'waiting' || kind === 'subagent'
            ? 'pending'
            : 'running'

  return (
    <div
      className="agent-activity-bar mb-1.5 flex min-w-0 items-center gap-2 text-[12px] leading-5 text-ink-soft"
      aria-live="polite"
    >
      <AgentStatusDotSlot status={status} size="sm" />
      <span className="min-w-0 flex-1 truncate">
        {kind && kind !== 'done' && kind !== 'error' ? (
          <span className="mr-1.5 text-[11px] text-ink-soft/75">{KIND_HINT[kind]}</span>
        ) : null}
        {label}
      </span>
      {running && kind !== 'done' && kind !== 'confirm' ? (
        <span
          className="inline-block size-3 shrink-0 animate-spin rounded-full border-2 border-[color-mix(in_srgb,var(--accent)_55%,transparent)] border-t-transparent"
          aria-hidden
        />
      ) : null}
    </div>
  )
}
